<template>
  <v-app>
    <app-bar-and-drawer v-if="showAppBar"></app-bar-and-drawer>
    <v-main>
      <router-view></router-view>
    </v-main>
    <feedback-message /> 
  </v-app>
</template>

<script>
import AppBarAndDrawer from "./components/AppBarAndDrawer.vue";
import FeedbackMessage from "./components/FeedbackMessage.vue";

export default {
  data: () => ({
    showAppBar: false,
  }),
  components: {
    AppBarAndDrawer,
    FeedbackMessage
  },
  watch: {
    $route(value) {
      const routesWithoutAppBar = ["login", "not-found"]; // Defina aqui as rotas sem AppBar
      this.showAppBar = !routesWithoutAppBar.includes(value.name); // Verifica se a rota atual deve ou não exibir o AppBar
    },
  },
};
</script>
